import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { Icon } from 'src/common/components/templateDetails/TemplateDetails.styled';

export const MainHeading = styled.div`
    font-size: 18px;
    margin: 0px 0 0 0;
    font-family: 'AvenirNextWorld Demi';
    color: #130e4a;
    opacity: 1;
    ${media.mobileDevice` 
    margin: 10px 10px 0 0;
    `}
`;

export const UserHeading = styled.div`
    font-size: 16px;
    margin: 18px 0 0 0;
    font-family: 'AvenirNextWorld Regular';
    opacity: 1;
`;


export const UserName1 = styled.div`
    margin-top: 12px;
`;


export const CloseIcon = styled(Icon)`
    margin: 3px 0 0 37px;
    ${media.mobileDevice` 
    margin: 13px 0px 0 0;
    `}
`;


export const Username = styled.div`
    margin: 3px 16px 0 9px;
    font-family: 'AvenirNextWorld Demi';
    font-size: 16px;
`;


export const User = styled.div`
    display: inline-block;
    /* margin: auto; */
    ${media.mobileDevice`
display:inline-block`}
`;


export const TextBold = styled.div`
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    display: flex;
    letter-spacing: -0.12px;
    align-self: center;
`;


export const Designation = styled.div`
    margin: auto;
    font-family: 'AvenirNextWorld Regular';
    font-size: 14px;
    color: #202124;
    opacity: 0.7;
    margin-left: 9px;
    ${media.mobileDevice`
        margin: 0 0 0 12px;`};
`;


export const BottomNavigationButtonContainer = styled.div`
    display: flex;
    margin-top: 14px;
    background-color: white;
    justify-content: ${(props) =>
        props.justifyContent ? props.justifyContent : 'center'};
   
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
        /* For portrait layouts only */
        justify-content: ${({ smallJustifyContent }) =>
            smallJustifyContent ? smallJustifyContent : 'flex-end'};
        padding-right: 0px;
        padding: ${(props) => (props.mbPadding ? props.mbPadding : '0px')};
    }
    ${media.smalDevice`    
        background-color: #FFFFFF;
          padding: ${(props) =>
              props.ipadPadding ? props.ipadPadding : '0px'};`}
    ${media.mobileDevice` 
        
         background-color: #FFFFFF;
           padding: ${(props) => (props.mbPadding ? props.mbPadding : '0px')};`}
`;